import { render, staticRenderFns } from "./coderOutpatientDxs.vue?vue&type=template&id=3706aa9b&scoped=true&"
import script from "./coderOutpatientDxs.vue?vue&type=script&lang=js&"
export * from "./coderOutpatientDxs.vue?vue&type=script&lang=js&"
import style0 from "./coderOutpatientDxs.vue?vue&type=style&index=0&id=3706aa9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3706aa9b",
  null
  
)

export default component.exports